module.exports = __webpack_public_path__ + "img/good7.02c0eac8.jpg";